import { render, staticRenderFns } from "./TrashedInspections.vue?vue&type=template&id=8d251a80&"
import script from "./TrashedInspections.vue?vue&type=script&lang=js&"
export * from "./TrashedInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports